<div *ngIf="!showTheStarter && !data.errorMessage" >
    <app-dialog-close-button class="close-button" (closed)="cancel()"></app-dialog-close-button>
</div>

<!-- SHOW THIS IF THERE IS A CUSTOMIZED ERROR MESSAGE -->
<div *ngIf="data.errorMessage" class="err-div">
    <vng-icon name="close" [outline]="false" class="close-button-icon-err" (click)="cancel()"></vng-icon>
    <div style="text-align: center">
        <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31 5.8125C26.0184 5.8125 21.1486 7.28972 17.0066 10.0574C12.8645 12.825 9.63618 16.7587 7.7298 21.3612C5.82341 25.9636 5.32462 31.0279 6.29648 35.9138C7.26835 40.7997 9.66722 45.2877 13.1898 48.8103C16.7123 52.3328 21.2003 54.7317 26.0862 55.7035C30.9721 56.6754 36.0364 56.1766 40.6388 54.2702C45.2413 52.3638 49.175 49.1355 51.9427 44.9934C54.7103 40.8514 56.1875 35.9816 56.1875 31C56.1811 24.3218 53.5254 17.919 48.8032 13.1968C44.081 8.47465 37.6782 5.81891 31 5.8125ZM31 52.3125C26.7848 52.3125 22.6642 51.0625 19.1594 48.7207C15.6546 46.3788 12.9229 43.0503 11.3098 39.1559C9.69674 35.2616 9.27468 30.9764 10.097 26.8421C10.9194 22.7079 12.9492 18.9104 15.9298 15.9298C18.9104 12.9492 22.7079 10.9194 26.8421 10.097C30.9764 9.27467 35.2616 9.69672 39.156 11.3098C43.0503 12.9229 46.3789 15.6546 48.7207 19.1594C51.0626 22.6642 52.3125 26.7848 52.3125 31C52.3061 36.6505 50.0586 42.0677 46.0631 46.0631C42.0677 50.0586 36.6505 52.3061 31 52.3125ZM34.875 42.625C34.875 43.1389 34.6709 43.6317 34.3075 43.995C33.9442 44.3584 33.4514 44.5625 32.9375 44.5625H31C30.4862 44.5625 29.9933 44.3584 29.63 43.995C29.2666 43.6317 29.0625 43.1389 29.0625 42.625V31C28.5487 31 28.0558 30.7959 27.6925 30.4325C27.3291 30.0692 27.125 29.5764 27.125 29.0625C27.125 28.5486 27.3291 28.0558 27.6925 27.6925C28.0558 27.3291 28.5487 27.125 29.0625 27.125H31C31.5139 27.125 32.0067 27.3291 32.37 27.6925C32.7334 28.0558 32.9375 28.5486 32.9375 29.0625V40.6875C33.4514 40.6875 33.9442 40.8916 34.3075 41.255C34.6709 41.6183 34.875 42.1111 34.875 42.625ZM27.6094 20.3438C27.6094 19.7689 27.7798 19.2071 28.0992 18.7291C28.4185 18.2512 28.8724 17.8787 29.4035 17.6587C29.9345 17.4388 30.5189 17.3812 31.0826 17.4933C31.6464 17.6055 32.1642 17.8823 32.5707 18.2887C32.9771 18.6952 33.2539 19.213 33.366 19.7768C33.4782 20.3405 33.4206 20.9249 33.2007 21.4559C32.9807 21.987 32.6082 22.4409 32.1303 22.7602C31.6523 23.0796 31.0904 23.25 30.5156 23.25C29.7449 23.25 29.0056 22.9438 28.4606 22.3988C27.9156 21.8538 27.6094 21.1145 27.6094 20.3438Z" fill="#F15A2A"/>
        </svg>
        <p style="color: rgba(117, 117, 117, 1);">{{data.errorMessage}} <b>{{data?.flycut}}</b> {{data?.errorMessage2}}</p>
        <button (click)="cancel()" vng-button variant="primary">
            Cancel
        </button>
    </div>
</div>

<!-- SHOW THIS IF THERE IS NO CUSTOMIZED ERROR MESSAGE -->
<div *ngIf="!data.errorMessage">
    <div *ngIf="showTheStarter" >
        <app-dialog-close-button class="close-button" (closed)="cancel()"></app-dialog-close-button>
    </div>
    <div style="display:flex; flex-direction:column; justify-content:space-between; align-items:center" class="warning-header">
        <div class="warning-title">
            <p>{{title}}</p>
        </div>
        <div class="warning-sub-title" [ngClass]="{'fly-warning': data.type == 'flyLearningWarning'}">
            <p style="margin: 3px; line-height: 18px;">
                <img *ngIf="data.type == 'flyLearningWarning'"  style="vertical-align: bottom" src="../../../assets/images/warning.png" alt="">
                {{message}}
            </p>
        </div>
    </div>
    <div *ngIf="errorMsg" style="display:flex; justify-content:center; align-items:center">
        <p class="warn-txt" style="margin: 6px 0;">
            <img style="vertical-align: bottom" src="../../../assets/images/warning.png" alt="">
            <span> {{errorMsg}}</span>
        </p>
    </div>
    <div class="plans-row">
        <div *ngIf="showTheStarter && selectedPlan !== 'salesPro'" class="starter-plan-card plan-card-half">
            <h2>Starter</h2>
            <h1 class="starter-price">${{displayedPrice(pricing['starter']/12)}}/mo</h1>
            <p class="starter-price bill-desc">*Billed annually at
                ${{displayedPrice(pricing['starter'])}} per user</p>
            <div class="starter-desc">
                <div *ngFor="let item of starterPlanDesc">
                    <p style="margin: 4px 0;">{{item}}</p>
                </div>
            </div>
            <button vng-button variant="primary" class="starter-btn" (click)="navigateTo('starter')">Choose Starter</button>

        </div>
        <div *ngIf="showTheStarter && selectedPlan !== 'salesPro'" class="growth-plan-card plan-card-half">
            <div class="recommended">
                <h3 style="color: #FFFFFF; margin: 0;">Recommended</h3>
            </div>
            <h2 style="color: #FFFFFF;">Growth</h2>
            <h1 class="growth-price">${{displayedPrice(pricing['growth']/12)}}/mo*</h1>
            <p class="growth-price bill-desc" style="font-weight: 400; font-size: 15px;">*Billed annually at
                ${{displayedPrice(pricing['growth'])}} per user</p>
            <div class="growth-desc">
                <div *ngFor="let item of growthPlanDesc">
                    <p style="margin: 4px 0;">{{item}}</p>
                </div>
            </div>
            <button vng-button variant="primary" class="growth-btn" (click)="navigateTo('growth')">Choose Growth</button>
        </div>
        <div *ngIf="!showTheStarter && selectedPlan !== 'salesPro'" class="growth-plan-card" style="display:flex; flex-direction:column; justify-content:center; align-items:center; padding-bottom:2rem; flex:1 1 100%; max-width:100%">
            <div class="recommended">
                <h3 style="color: #FFFFFF; margin: 0;">Recommended</h3>
            </div>
            <h2 style="color: #FFFFFF;">Growth</h2>
            <h1 class="growth-price">${{displayedPrice(pricing['growth']/12)}}/mo*</h1>
            <p class="growth-price bill-desc">*Billed annually at ${{displayedPrice(pricing['growth'])}} per user</p>
            <div class="growth-desc">
                <div *ngFor="let item of growthPlanDesc">
                    <p style="margin: 4px 0;">{{item}}</p>
                </div>
            </div>
            <button vng-button variant="primary" class="growth-btn" (click)="navigateTo('growth')">
                {{upgrade && upgrade ? upgrade :"Choose Growth"}}
            </button>
        </div>
        <div *ngIf="selectedPlan === 'salesPro'" class="sales-pro-plan-card" [ngClass]="{'fly-warning-content': data.type == 'flyLearningWarning'}" style="display:flex; flex-direction:column; justify-content:center; align-items:center; padding-bottom:2rem; flex:1 1 100%; max-width:100%">
            <h2 style="color: #FFFFFF;">Business Pro</h2>
            <h1 class="sales-pro-price">${{displayedPrice(pricing['salesPro']/12)}}/mo*</h1>
            <p class="sales-pro-price bill-desc">*Billed annually at ${{displayedPrice(pricing['salesPro'])}} per user</p>
            <div class="sales-pro-desc">
                <div *ngFor="let item of salesProPlanDesc">
                    <p style="margin: 4px 0;">{{item}}</p>
                </div>
            </div>
            <button vng-button variant="primary" class="sales-pro-btn" (click)="navigateTo('sales-pro')">Choose Business Pro</button>
        </div>
    </div>

    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center">
        <p style="margin: 0;">
            <a  href="/plans">
                <div class="plans-compare" style="display:flex; justify-content:center; align-items:center">
                    Compare Plans&nbsp;<img src="/assets/images/arrow_right_alt.png" alt="">
                </div>
            </a>
        </p>
    </div>
</div>
